import { render, staticRenderFns } from "./InvoiceOptionsDropdown.vue?vue&type=template&id=4063b63e&scoped=true"
import script from "./InvoiceOptionsDropdown.vue?vue&type=script&lang=js"
export * from "./InvoiceOptionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./InvoiceOptionsDropdown.vue?vue&type=style&index=0&id=4063b63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4063b63e",
  null
  
)

export default component.exports